import React from 'react'
import dayjs, { OpUnitType } from 'dayjs'
import ChartJS, {
  IChartJSProps
} from '../../../../../components/common/charts/ChartJS'
import { TimeUnitEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'

interface ICustomMetricChartProps extends IChartJSProps {
  from: Date
  to: Date
  config: Chart.ChartConfiguration
  chartData: IChartDataProps[]
  color: string
  target: number | null | undefined
}

export interface IChartDataItem {
  value: number
  timestamp: string
}

export interface IChartDataProps {
  color?: string
  timestamp: string
  value: number
}

function buildChartJSData(
  data: IChartDataProps[],
  target: number | null | undefined,
  from: Date,
  to: Date,
  color?: string
) {
  const ldateFmt = 'DD/MM/YY'
  const dateFmt = 'D MMM'
  const labels: string[] = []
  const granularity = TimeUnitEnum.DAY

  const rowData = {
    data: [] as any[],
    borderWidth: 5,
    stepped: true,
    pointRadius: 0,
    lineTension: 0.3,
    borderColor: color ? color : '#BD10E0',
    pointBackgroundColor: color ? color : '#BD10E0',
    backgroundColor: 'rgba(60,94,102,.03)'
  }

  const graphData: Array<
    typeof rowData & {
      borderDash?: number[]
    }
  > = []

  let date = dayjs(from)
  while (date.isBefore(dayjs(to).add(1, 'day'))) {
    const ldate = dayjs(date)
      .startOf(granularity.toLowerCase() as OpUnitType)
      .format(ldateFmt)

    let countForDate = 0
    const found = data.find((dataItem) => {
      const x = dayjs(dataItem.timestamp)
        .startOf(granularity.toLowerCase() as OpUnitType)
        .format(ldateFmt)
      if (ldate === x) {
        countForDate += dataItem.value
        return true
      }
      return false
    })
    if (found) {
      rowData.data.push(countForDate)
      const label = dayjs(date)
        .startOf(granularity.toLowerCase() as OpUnitType)
        .format(dateFmt)
      if (!labels.includes(label)) {
        labels.push(label)
      }
    }

    date = dayjs(date).add(1, granularity.toLocaleLowerCase() as OpUnitType)
  }

  graphData.push(rowData)
  graphData.push({
    data: new Array(rowData.data.length).fill(target),
    borderDash: [10, 5],
    borderWidth: 2,
    stepped: true,
    pointRadius: 0,
    lineTension: 0.3,
    borderColor: '#C8C8C8',
    pointBackgroundColor: '#BD10E0',
    backgroundColor: 'rgba(60,94,102,.03)'
  })

  return {
    labels,
    datasets: graphData,
    noData: !data.length
  }
}

export const CustomMetricChart = ({
  from,
  to,
  chartData,
  target,
  color,
  config,
  ...props
}: ICustomMetricChartProps) => {
  config.data = buildChartJSData(chartData, target, from, to, color)
  return <ChartJS {...props} config={config} />
}
